import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * Public settings — exposed without auth so marketing pages can react to
 * admin toggles (e.g. hide the price calculator). Single source of truth
 * is `/api/settings/public`; falls back to safe defaults on network errors
 * so the page always renders.
 */
export default function usePublicSettings() {
  const [settings, setSettings] = useState({
    pricing_calculator_enabled: true,
    bookings_enabled: true,
    bookings_closed_message: "",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api.get("/settings/public")
      .then(({ data }) => { if (alive) setSettings(s => ({ ...s, ...data })); })
      .catch(() => { /* keep defaults */ })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  return { settings, loading };
}
